import {
    CLEANING_ACCOUNT_NUMBER_PATTERN,
    CLEANING_PHONE_PATTERN,
    DOUBLE_FIGURES_PATTERN,
    EMAIL_PATTERN,
    FIGURES_PATTERN,
    LATIN_PATTERN,
    LOGIN_PATTERN,
    MOBILE_DEVICES_PATTERN,
    PHONE_PATTERN,
    URL_PATTERN,
    WHOLE_AND_FRACTIONAL_NUMBERS_PATTERN,
} from 'constants/regExpPatterns';

export class ValidationService {
    private static _regExpFormat: (pattern: string | RegExp) => RegExp = (pattern: string | RegExp): RegExp =>
        new RegExp(pattern, 'i');

    public static get isLoggedInFromAMobile(): boolean {
        return this._regExpFormat(MOBILE_DEVICES_PATTERN).test(navigator.userAgent);
    }

    public static isEmailValid(value: string): boolean {
        return this._regExpFormat(EMAIL_PATTERN).test(value);
    }

    public static isLatinValid(value: string): boolean {
        return this._regExpFormat(LATIN_PATTERN).test(value);
    }

    public static isPhoneValid(value: string): boolean {
        return this._regExpFormat(PHONE_PATTERN).test(value);
    }

    public static isUrlValid(value: string): boolean {
        return this._regExpFormat(URL_PATTERN).test(value);
    }

    public static isLoginValid(value: string): boolean {
        return this._regExpFormat(LOGIN_PATTERN).test(value);
    }

    public static isDoubleFigures(value: string): boolean {
        return this._regExpFormat(DOUBLE_FIGURES_PATTERN).test(value);
    }

    public static isWholeFractionalNumb(value: string): boolean {
        return this._regExpFormat(WHOLE_AND_FRACTIONAL_NUMBERS_PATTERN).test(value);
    }

    public static isWholeFractionalNumbAndDote(value: string): boolean {
        return this._regExpFormat('^\\d+(\\.)?(\\d{1,8})?$').test(value);
    }

    public static isFiguresValid(value: string): boolean {
        return this._regExpFormat(FIGURES_PATTERN).test(value);
    }

    public static clearPhoneMask(val: string): string {
        // todo check how is working this code
        return val.replace(CLEANING_PHONE_PATTERN, '');
    }

    public static clearAccountNumberMask(val: string): string {
        return val.replace(CLEANING_ACCOUNT_NUMBER_PATTERN, '').substring(1);
    }
}
